import React from 'react';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import top3 from '../images/top3.png'; // Adjust path if needed
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import '../css/AdvertisementTopResale.css';
import dummyImg from '../images/no-image-thumb.jpg'
import generateSlug from './common/generateSlug';
// Custom Previous Arrow Component
const PrevArrow = ({ onClick }) => (
  <button className="unique-btn unique-btn-prev" onClick={onClick}>
    &lt;
  </button>
);

// Custom Next Arrow Component
const NextArrow = ({ onClick }) => (
  <button className="unique-btn unique-btn-next" onClick={onClick}>
    &gt;
  </button>
);

const handleLinkClick=(project)=>{
  //alert(JSON.stringify(project))
  // let url = '';
  // url = `/sell-pid-${project.project_id}`;
  const url = generateSlug(project);
  window.location.href = url; 
  localStorage.setItem('last-property-seen', JSON.stringify({ id: project.project_id, typeWithId: url }))
}

const AdvertisementTopResale = ({ param, topProjects }) => {
  const settings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
  };
  

  return (
    <>
    {topProjects?.length > 0 && (
    <div className='top_resale desk mt-4 mb-4'>
      <p>Top Resale Projects in {param?.name}</p>
      
      <div className="titleunderline">
        <svg width="71" height="7" viewBox="0 0 71 7" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0.113249 3.5L3 6.38675L5.88675 3.5L3 0.613249L0.113249 3.5ZM70.8867 3.5L68 0.613249L65.1132 3.5L68 6.38675L70.8867 3.5ZM3 4H68V3H3V4Z" fill="#002842" />
          <line x1="8.5" y1="6.5" x2="62.5" y2="6.5" stroke="#002842" stroke-linecap="round" />
        </svg>
      </div>


      <div className="unique-carousel">
        <Slider {...settings}>
          {topProjects?.length > 0 && topProjects.map((project, index) => (
          
            <div className="carousel-item unique-slide" key={index}>
                <Link onClick={() => handleLinkClick(project)}>
              <img src={project?.property_image[0]?.image || top3} className="card-img-top" alt="..."  onError={(e) => {
                                  e.target.onerror = null; // prevent infinite loop
                                  e.target.src = dummyImg; // fallback image path
                                }}/>
              <div className="unique-overlay">
                <h3>{project?.project_name}</h3>
                <p>{project?.sub_locality_name}</p>
              </div>
              </Link>
            </div>
            
          ))}
        </Slider>
      </div>
    </div>
       )}
    </>
  );
};

export default AdvertisementTopResale;
